import appConfig from "appConfig";
import moment from "moment";

async function getTeamTable(
  teamCode,
  date,
  gender,
  numberOfPastMatches = -1,
  numberOfNextMatches = 0,
  accessToken
) {
  // Ensure the date is in the correct format
  const formattedDate = moment(date).format("YYYY-MM-DD");

  const url =`${appConfig.apiBaseUrl}/GetTeamTable?team_code=${encodeURIComponent(
    teamCode
  )}&date_Y_m_d=${encodeURIComponent(
    formattedDate
  )}&number_of_past_matches=${encodeURIComponent(
    numberOfPastMatches
  )}&number_of_next_matches=${encodeURIComponent(
    numberOfNextMatches
  )}&gender=${encodeURIComponent(gender)}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    throw new Error("Failed to fetch team table data: " + response.statusText);
  }

  // Read response as text
  const responseText = await response.text();

  // Santitize text. Replace NaN with null.
  const sanitizedText = responseText.replace(/\bNaN\b/g, "null");

  // Parse the sanitized text
  return JSON.parse(sanitizedText);
}

export default getTeamTable;
